<template>
  <div>
    <input :id="id" ref="input" type="file" :accept="accept" class="sr-only"
           @change="e=> {this.file = e.target.files[0]}"/>
    <div class="group" @mouseover="mover = true" @mouseleave="mover = false">
      <div class="relative flex justify-center rounded-md"
           :class="[isDrag ? 'border-primary-500  border-dashed ' : 'border-gray-300', file ? 'border' : 'border-2  border-dashed']">
        <img :class="imgCls" v-if="user_file.url" class="rounded-md" alt="" :src="user_file.url"/>
        <div v-else class="space-y-1 text-center px-6 pt-5 pb-6">
          <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48"
               aria-hidden="true">
            <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div class="flex text-sm text-gray-600">
            <label :for="id" class="group-hover:text-primary-500 link">Выберете файл</label>
            <span class="pl-1">или перетащите</span>
          </div>
          <p class="text-xs text-gray-500"> {{ helpText }} </p>
        </div>
        <label :for="id" class="absolute z-10 w-full top-0 right-0 h-full bg-white cursor-pointer"
               :class="isDrag ? 'opacity-30' : 'opacity-0' " ref="area"></label>
      </div>
    </div>
    <div class="w-full mt-1 space-x-4 z-20 text-center text-sm" v-show="user_file.url">
      <label :for="id" class="link" tabindex="0"> Обновить </label>
      <span class="text-gray-300" aria-hidden="true">|</span>
      <span tabindex="0" class="link" @click="removeFile">Удалить</span>
    </div>
  </div>
</template>

<script>

import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";


export default {
  name: "UiFormImage",
  setup: setup,
  mixins: [mixin],
  props: {
    url: {
      default: '/files',
    },
    helpText: {
      default: 'PNG, JPG до 10MB'
    },
    accept: {
      default: 'image/*'
    },
    name: {default: 'image'},
    server_image: {
      default: null
    },
    imgCls: {
      default: ''
    }
  },
  data() {
    return {
      mover: false,
      dragAndDropCapable: false,
      //files: [],
      file: null,
      user_file: {url: null},
      isDrag: false,
      error: '',
      percent: 0,
      in_progress: false,
    }
  },

  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.area.addEventListener(evt, function (e) {
          if (e.type === 'dragenter')
            this.isDrag = true
          if (e.type === 'dragleave')
            this.isDrag = false

          e.preventDefault();
          e.stopPropagation();

        }.bind(this), false);
      }.bind(this));

      this.$refs.area.addEventListener('drop', function (e) {
        this.file = e.dataTransfer.files[0];
        this.isDrag = false
      }.bind(this));

    }
    if (this.server_image) {
      this.user_file = this.server_image;
    }
  },

  methods: {
    determineDragAndDropCapable() {
      let div = document.createElement('div');
      return (('draggable' in div)
              || ('ondragstart' in div && 'ondrop' in div))
          && 'FormData' in window
          && 'FileReader' in window;
    },

    async removeFile() {
      await this.$api.files.remove(this.url, this.user_file.id);
      this.user_file = {url: null};
      this.file = null;
    },


    upload() {

      this.$parent.local_errors = []
      // this.test(idx)
      this.percent = 0;
      this.in_progress = true;
      this.user_file = {};

      this.$api.files.store(this.url, this.name, this.file, (event) => {
        this.percent = Math.round(100 * event.loaded / event.total);
      }).then((response) => {
        if (response.data.id) {
          this.user_file = (response.data)
          this.in_progress = false
        } else {
          this.$store.dispatch('alerts/error', {text: 'Не удалась загрузить файл, неизвестная ошибка'})
        }
      }).catch((e) => {
        console.log(e)
        if (e[this.name]) {
          this.$parent.local_errors = e[this.name]
        } else {
          this.$store.dispatch('alerts/error', {text: 'Не удалась загрузить файл, неизвестная ошибка'})
        }
        this.in_progress = false
      });
    },

  },
  watch: {
    file() {
      if (!this.file) {
        return
      }
      this.upload();
    }
  },

}
</script>
